import { PAYWALL_LOCAL_STORAGE_KEY } from "./authOperations";


export const productClientId = 'newspaper';


export function getCurrentUser() {
    const user = localStorage.getItem('paywall');
    if(user) {
        return JSON.parse(user);
    }
}

export function removeCurrentUser() {
    localStorage.removeItem('paywall');
}



function getUsernameFromEmail(email:string) {
    return typeof email === 'string' && email.includes('@')
      ? email.split('@')[0]
      : 'משתמש';
  }

  function getDisplayName(user) {
    const firstName = user.firstname && user.firstname.value ? user.firstname.value.trim() : '';
    const email = user.email && user.email.value ? user.email.value : '';
  
    if (firstName) {
      return `${firstName}`;
    } else {
      return getUsernameFromEmail(email);
    }
  }



export function setCurrentUser(user) {
    const paywallObject = {
        displayName: getDisplayName(user)
    }
    localStorage.setItem(PAYWALL_LOCAL_STORAGE_KEY, JSON.stringify(paywallObject));
}

